import { Hammer, ScanSearch } from "lucide-react";

const INTRO = {
  experience: [ScanSearch, "Experience review", "AI checks each past role against the job. Runs automatically when a candidate reaches Experience review."],
  work_sample: [Hammer, "Work sample", "A short timed practical task you approve first. Only on jobs where it's switched on."],
};

export function TabIntro({ kind }) {
  const [Icon, title, text] = INTRO[kind];
  return (
    <div className="flex items-start gap-3" data-testid={`tab-intro-${kind}`}>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[5px] bg-brand-tint text-brand"><Icon size={18} aria-hidden="true" /></span>
      <div><h2 className="text-lg font-semibold text-ink">{title}</h2><p className="text-sm text-ink-secondary" data-testid={`tab-intro-${kind}-text`}>{text}</p></div>
    </div>
  );
}
